import { Modal, Spinner } from "react-bootstrap";
import { faCheckCircle, faTimesCircle } from "@fortawesome/free-regular-svg-icons";
import { useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const BasicProcessingModal = ({ status, onClose, time }) => {

  const successIcon = <FontAwesomeIcon icon={faCheckCircle} style={{ color: "#a5dc86", fontSize: 80, marginBottom: 20 }} />;
  const errorIcon = <FontAwesomeIcon icon={faTimesCircle} style={{ color: "#ff2e2e", fontSize: 80, marginBottom: 20 }} />;

  useEffect(() => {
    if (status.status === "success" || status.status === "error") {
      const timer = setTimeout(() => {
        onClose(); // Cierra el modal después de 3 segundos
      }, time);
      return () => clearTimeout(timer);
    }
  }, [status, onClose]);

  return (
    <Modal show={!!status.status} backdrop="static" animation={false} centered>
      <Modal.Body className="mt-5">
        <div className="d-flex flex-column justify-content-center align-items-center">
          {status.status === "processing" && (
            <>
              <Spinner animation="border" style={{ color: "#0477AD", width: 50, height: 50 }} />
              <h2 className="mt-3 mb-5">{status.message}</h2>
            </>
          )}
          {status.status === "success" && (
            <>
              {successIcon}
              <h2 className="mt-3 mb-5 text-success">{status.message}</h2>
            </>
          )}
          {status.status === "error" && (
            <>
              {errorIcon}
              <h2 className="mt-3 mb-5 text-danger">{status.message}</h2>
            </>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default BasicProcessingModal;